<div class="header-screen">

  <div class="filter-sidebar-wrapper" [class.collapsed]="isManuallyCollapsedRail">

    <!-- MANUALLY COLLAPSED — narrow 40px vertical rail -->
    <div *ngIf="isManuallyCollapsedRail" class="filter-header-row">
      <span class="filter-title">FILTERS</span>
      <button
        type="button"
        class="chevron-btn"
        (click)="onHeaderArrowClick()"
        aria-label="Expand filters">
        <mat-icon>{{ headerArrowIcon }}</mat-icon>
      </button>
    </div>

    <!-- DIALOG-COLLAPSED — wide horizontal summary chip -->
    <div
      *ngIf="effectiveCollapsed"
      class="filter-summary-chip"
      (click)="toggleSummaryExpand()">

      <span class="filter-summary-label">FILTERS</span>

      <mat-icon class="filter-summary-chevron">
        {{ manuallyExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </mat-icon>

    </div>

    <!-- FULL FORM — shown whenever neither collapsed state applies -->
    <ng-container *ngIf="!isManuallyCollapsedRail && !effectiveCollapsed">

      <div class="filter-header-row">
        <span class="filter-title">FILTERS</span>
        <button
          type="button"
          class="chevron-btn"
          (click)="onHeaderArrowClick()"
          [attr.aria-label]="isFilterOpen ? 'Collapse filters' : 'Expand filters'"
        >
          <mat-icon>{{ headerArrowIcon }}</mat-icon>
        </button>
      </div>

      <div class="filter-sidebar-content">

        <form [formGroup]="entryForm" class="flex flex-col" >

          <div class="filter-field">
            <ng-select
              [items]="clientList"
              bindLabel="ClientDescription"
              bindValue="Client"
              placeholder="Select Client"
              formControlName="clientDropDown"
              multiple="true"
            >
            </ng-select>
          </div>

          <div class="filter-field">
            <ng-select
              [items]="projectList"
              bindLabel="ProjectDescription"
              bindValue="Project"
              placeholder="Select Project"
              formControlName="projectDropDown"
              multiple="true"
            >
            </ng-select>
          </div>

          <div class="filter-field">
            <ng-select
              [items]="employeeList"
              bindLabel="FullName"
              bindValue="Employee"
              placeholder="Select Consultant"
              formControlName="employeeDropDown"
              multiple="true"
            >
            </ng-select>
          </div>

          <!-- Period (date range) -->
          <div class="filter-field date-picker">
            <label class="filter-label">Period</label>
            <mat-form-field class="w-full">
              <mat-date-range-input [rangePicker]="rangePicker" formGroupName="dateRange">
                <input
                  matStartDate
                  formControlName="startDate"
                  placeholder="Start Date"
                  readonly
                  (click)="rangePicker.open()"
                />
                <input
                  matEndDate
                  formControlName="endDate"
                  placeholder="End Date"
                  readonly
                  (click)="rangePicker.open()"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #rangePicker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <!-- Charge + checkboxes on one line -->
          <div class="filter-inline-row filter-field-checkbox-row">
            <div class="filter-field charge-field">
              <ng-select
                [items]="chargeOptions"
                placeholder="Select Charge"
                formControlName="chargeDropDown"
              >
              </ng-select>
            </div>

            <mat-checkbox formControlName="firstCheckbox">Show Clashes</mat-checkbox>
            <mat-checkbox formControlName="secondCheckbox">Show Entries</mat-checkbox>
          </div>

          </form>
          </div>

    </ng-container>

  </div>

</div>